<template>
  <transition name="task">
    <div class="task"
      tabindex="0"
      @keyup.49="category === CATEGORY.SCORE5 && key(1)"
      @keyup.50="category === CATEGORY.SCORE5 && key(2)"
      @keyup.51="category === CATEGORY.SCORE5 && key(3)"
      @keyup.52="category === CATEGORY.SCORE5 && key(4)"
      @keyup.53="category === CATEGORY.SCORE5 && key(5)"
      @keyup.right="category === CATEGORY.SWING && key('✔️')"
      @keyup.left="category === CATEGORY.SWING && key('❌')"
      @keyup.down="category === CATEGORY.SWING && key('🤨')"
      @keyup.up="openCommentDialog"
      :style="styleThrowFeedback">
      <!-- disable debug control -->
      <!-- <div style="position: fixed; top: 0; right: 0; color: black;">
        <div @click=" addCard ">增加</div>
        <div>
          <a @click="category=this.CATEGORY.SWING" style="color: black !important;">swing</a>
          <span> | </span>
          <a @click="category=this.CATEGORY.SCORE5" style="color: black !important;">score5</a>
        </div>
      </div> -->
      <v-dialog
        v-model="dialog"
        width="70%"
        :persistent="true"
      >
        <v-card
          :style="{'padding': '1rem'}">
          <v-card-text>
            <v-textarea
              ref="textarea"
              outline
              name="input-7-4"
              :hide-details="true"
              v-model="comment"
              label="你有什么想法？">
            </v-textarea>
          </v-card-text>
          <v-card-actions
            :style="{'justify-content':'center'}">
            <v-btn
              color="primary"
              @click="submitComment"
            >
              提交
            </v-btn>
            <v-btn
              color="primary"
              @click="cancelComment"
            >
              取消
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div v-if="task.finished === task.total && task.total >= 0">
        <div class="congratulations">
          恭喜你，全部完成了！
          <Fireworks :boxHeight="'100%'" :boxWidth="'100%'"/>
        </div>
      </div>
      <div v-else>
        <transition-group name="card" enter-stagger="50">
          <Card v-for="card in cards"
            class="item"
            :key="card.id"
            :type="type"
            :category="category"
            :isTop="topCard.id === card.id"
            :info="card"
          />
        </transition-group>
      </div>
      <div v-if="category === this.CATEGORY.SCORE5" class="keyboard" >
        <div v-for="n in 5" :key="n" class="key"
          @click="key(n)">
          {{n}}
        </div>
      </div>
      <div v-else-if="category === this.CATEGORY.SWING" class="keyboard swing">
        <div class="key"
          @click="key('❌')">
          ❌
        </div>
        <div class="key"
          @click="key('🤨')">
          🤨
        </div>
        <div class="key"
          @click="key('✔️')">
          ✔️
        </div>
      </div>
      <div class="progress" v-text="`${$store.state.task.finished} / ${$store.state.task.total}`" />
    </div>
  </transition>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
// import fakedata from '@/fakedata'
import VueSwing from 'vue-swing'
import { Card, Fireworks } from '@/components'

export default {
  name: 'task',
  components: {
    Card,
    Fireworks
  },
  data () {
    return {
      dialog: false,
      comment: '',
      currentCardId: '',
      isfetchingNewCards: false,
      prevCardCount: 0
    }
  },
  computed: {
    ...mapState([
      'task',
      'throwState'
    ]),
    CATEGORY () {
      const SCORE5 = 'CATEGORY.SCORE5'
      const SWING = 'CATEGORY.SWING'
      return {
        SCORE5, SWING
      }
    },
    id () {
      return this.$route.params.id
    },
    type () {
      return this.task.card_type
    },
    category () {
      const score5cardTypes = ['similarity']
      return score5cardTypes.includes(this.task.card_type) ? this.CATEGORY.SCORE5 : this.CATEGORY.SWING
    },
    rawCards () {
      if (!this.task.cardList) {
        return []
      } else {
        return this.task.cardList
      }
    },
    cards () {
      if (this.rawCards.length > 0) {
        return this.rawCards.slice(0).reverse()
      } else {
        return []
      }
    },
    topCardItem () {
      return this.$refs.card0[0]
    },
    topCard () {
      return this.rawCards[0]
    },
    styleThrowFeedback () {
      let style = {
        'box-shadow': 'inset 0 0 0 0 rgba(0,0,0,0)'
      }
      if (!this.throwState.indicator) {
        // console.log('wow')
        // console.log(style)
        return style
      } else {
        let size = 500
        let coords = '0 0 0 0'
        let color = 'yellow'
        switch (this.throwState.direction) {
          case VueSwing.Direction.RIGHT:
            coords = `-${size}px 0 ${size}px -${size}px`
            // color_neon_green
            color = '#43F521'
            break
          case VueSwing.Direction.LEFT:
            coords = `${size}px 0 ${size}px -${size}px`
            // color_japonica
            color = '#DD786D'
            break
          case VueSwing.Direction.UP:
            coords = `0 ${size}px ${size}px -${size}px`
            break
          case VueSwing.Direction.DOWN:
            coords = `0 -${size}px ${size}px -${size}px`
            break
          default:
            return {}
        }
        style = {
          'box-shadow': `inset ${coords} ${color}`
        }
        return style
      }
    }
  },
  watch: {
    rawCards (newCards) {
      // all finished !!
      if (this.task.total > 0 && this.task.total === this.task.finished) {
        this.prevCardCount = 0
        return
      } else {
        // more cards arrived, which means fetch finished
        if (newCards.length > this.prevCardCount) {
          this.isfetchingNewCards = false
        }
        // fetch 5 cards when <3
        if (newCards.length < 3) {
          // don't fetch twice
          // only when there is no card
          if (newCards.length === 0 || !this.isfetchingNewCards) {
            this.addCard()
            this.isfetchingNewCards = true
          }
        }
        // update card count flag
        this.prevCardCount = newCards.length
      }
      // show comment when top card change
      if (newCards && newCards.length > 0 && !this.currentCardId === this.topCard.id) {
        this.comment = this.topCard.comment
        this.currentCardId = this.topCard.id
      }
    }
  },
  methods: {
    ...mapMutations([
      'clearTask',
      'throwCard',
      'resetCard'
    ]),
    ...mapActions([
      'fetch5cards',
      'commentCard'
    ]),
    addCard () {
      this.fetch5cards({ params: { id: this.id } })
    },
    key (value) {
      switch (value) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5: {
          this.topCardItem.scoreCard(value)
          break
        }
        case '❌': {
          this.throwCard({
            id: this.rawCards[0].id,
            direction: VueSwing.Direction.LEFT
          })
          // this.topCardItem.tagCardBad()
          break
        }
        case '🤨': {
          this.throwCard({
            id: this.rawCards[0].id,
            direction: VueSwing.Direction.DOWN
          })
          // this.topCardItem.tagCardConfused()
          break
        }
        case '✔️': {
          this.throwCard({
            id: this.rawCards[0].id,
            direction: VueSwing.Direction.RIGHT
          })
          // this.topCardItem.tagCardGood()
        }
      }
    },
    openCommentDialog () {
      this.dialog = true
    },
    cancelComment () {
      this.dialog = false
      this.resetCard()
    },
    submitComment (event) {
      if (this.comment.trim().length === 0) {
        this.cancelComment()
        return
      }
      this.dialog = false
      this.commentCard({
        id: this.topCard.id,
        comment: this.comment
      })
    }
  },
  mounted () {
    // focus to use keyboard
    this.$el.focus()
  }
}
</script>

<style lang="scss" scoped>
@import '@/stylesheets/function.scss';
@import '@/stylesheets/color.scss';
.task {
  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;

  transition: all .3s ease;

  background: radial-gradient(ellipse at bottom, lightgrey 0%, white 100%);
}

.progress {
  position: absolute;
  top: 1rem;
  opacity: .7;
}

.congratulations {
  color: $color_bleu_de_france;
  font-size: 2rem;
}

// fix: .card will confilct with component class name
// allow only top card
.item {
  pointer-events: none;
  &:nth-last-child(1) {
    pointer-events: all;
  }
}

// transitions
.task-enter {
  opacity: 0;
}
.task-enter-active{
  transition: all 1s cubic-bezier(0.165, 0.84, 0.44, 1);
}
.card-enter-active {
  transition: all .3s ease;
  @for $i from 1 through 15 {
    &.item:nth-child(#{$i}) {
      transition-delay: $i * .1s;
    }
  }
}
.card-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.card-enter, .card-leave-to{
  opacity: 0;
}
.card-enter {
  transform: translateY(100vh) rotate(0) !important;
}
$key_height: 15vw;

.keyboard {
  position: fixed;
  bottom: 0;
  left: 50%;
  right: 0;
  top: auto;
  height: $key_height;
  transform: translateX(-50%);
  width: $key_height * 5;
  max-height: 5rem;
  max-width: 25rem;

  $border_radius: rem(15);
  border-top-left-radius: $border_radius;
  border-top-right-radius: $border_radius;
  background: $color_concrete;
  // overflow: hidden;

  display: flex;
  justify-content: center;

  box-shadow: 0 0 .5rem rgba(0,0,0,.15);

  &.swing {
    $key_height: 20vw;
    height: $key_height;
    width: $key_height * 3;
    max-width: 5rem * 3;
    .key:nth-last-child(1) {
      color: transparent;
      text-shadow: 0 0 0 $color_neon_green;
    }
    .key:hover {
      &:nth-child(2) {
        background: linear-gradient(white 80%, rgb(255, 251, 0) 150%);
      }
      &:nth-child(3) {
        background: linear-gradient(white 80%, rgb(47, 255, 92) 150%);
      }
    }
  }

  .key {
    flex: 1;

    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 0;

    cursor: pointer;
    user-select: none;
    background: $color_concrete;

    font-size: 2.5rem;
    transition: all .3s cubic-bezier(0.165, 0.84, 0.44, 1);

    border-top-left-radius: $border_radius;
    border-top-right-radius: $border_radius;

    &:hover {
      transform: translateY(-10%) scale(1.2);
      z-index: 10;
      background: white;
      box-shadow: 0 0 1rem rgba(0,0,0,.3);

      // color: white;
      &:nth-child(1) {
        background: linear-gradient(white 80%, rgb(255, 38, 0) 150%);
      }
      &:nth-child(2) {
        background: linear-gradient(white 80%, orange 150%);
      }
      &:nth-child(3) {
        background: linear-gradient(white 80%, rgb(255, 251, 0) 150%);
      }
      &:nth-child(4) {
        background: linear-gradient(white 80%, rgb(224, 255, 47) 150%);
      }
      &:nth-child(5) {
        background: linear-gradient(white 80%, rgb(47, 255, 92) 150%);
      }
    }
  }
}
</style>
